import { render } from "./new-payable-account.vue?vue&type=template&id=f5d9cad2"
import script from "./new-payable-account.vue?vue&type=script&lang=js"
export * from "./new-payable-account.vue?vue&type=script&lang=js"

import "./new-payable-account.vue?vue&type=style&index=0&id=f5d9cad2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__